import React from "react";
import { Quote } from "../../../../types/IMultiLocationQuoteMobile";

interface MultiLocSetupRowProps {
  quote: Quote;
  onReviewResolveClick: (quote: Quote) => void;
  textColor?: string;
}

const MultiLocSetupRow: React.FC<MultiLocSetupRowProps> = ({
  quote,
  onReviewResolveClick,
  textColor,
}) => {
  const quoteKey = `${quote.origin.id || quote.origin.name}-${quote.mode}`;

  return (
    <div key={quoteKey} className="setup-row">
      <div id={`need-setup-${quoteKey}`} className="setup-name" style={{ color: textColor }}>
        {quote.origin.name}
      </div>
      <button
        id="review-resolve-button"
        type="button"
        className="review-resolve-btn"
        onClick={() => onReviewResolveClick(quote)}
      >
        Review & Resolve
      </button>
    </div>
  );
};

export default MultiLocSetupRow;
